import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-3 py-1 rounded font-bold text-lg group-hover:shadow-md transition-all">
              FDP
            </div>
            <span className="font-bold text-xl text-gray-800">Kai Alexander Bewig</span>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              Start
            </Link>
            <Link to="/kontakt" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              Kontakt
            </Link>
            <Link to="/impressum" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              Datenschutz
            </Link>
            <div className="bg-yellow-400 text-blue-900 px-4 py-2 rounded-full font-bold shadow-sm">
              Platz 3
            </div>
          </nav>

          <button 
            className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="h-6 w-6" />
          </button>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-gray-100">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-gray-50">
              <Link 
                to="/" 
                className="block px-3 py-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-white transition-all"
                onClick={() => setIsMenuOpen(false)}
              >
                Start
              </Link>
              <Link 
                to="/kontakt" 
                className="block px-3 py-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-white transition-all"
                onClick={() => setIsMenuOpen(false)}
              >
                Kontakt
              </Link>
              <Link 
                to="/impressum" 
                className="block px-3 py-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-white transition-all"
                onClick={() => setIsMenuOpen(false)}
              >
                Impressum
              </Link>
              <Link 
                to="/datenschutz" 
                className="block px-3 py-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-white transition-all"
                onClick={() => setIsMenuOpen(false)}
              >
                Datenschutz
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;